<script>
import TitleSlot from '@/components/TitleSlot'
import TextSlot from '@/components/TextSlot'
import Waves from '@/components/Waves'

export default
{
    name: 'features',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='features'>
                <div class='feature'>
                    <title-slot>Concentrez-vous sur ce qui compte vraiment  ⚡</title-slot>
                    <text-slot>
                        Vos ressources sont limitées, et gérer la conception d'une application est <b>long</b>, <b>couteux</b> et <b>fastidieux</b>.
                        <br />
                        Pourtant de plus en plus de villes sautent le pas car c'est un formidable moyen d'<b>établir une relation avec ses citoyens</b>.
                        <br />
                        <b>Ma Ville</b> est une solution tout en un qui vous permet de déployer une application à l'échelle de votre ville
                        et à faible coût. En moins d'une semaine, nous nous occupons de tout, ce qui vous laisse plus de temps pour <b>être là où l'on a besoin de vous</b>.
                    </text-slot>
                </div>
                <div class='feature'>
                    <Waves>
                        <div class='dual'>
                            <img class='image' src={require('@/assets/img/devices-mockup.png')} />
                            <div class='description'>
                                <title-slot>Une application pour tous les écrans</title-slot>
                                <text-slot>
                                    <b>Ma Ville</b> se décline pour les téléphones, tablettes, ordinateurs portables et bureaux; elle s'adapte en fonction de chaque écran.
                                    <br />
                                    Si vous êtes en déplacement vous pouvez consulter l'application de votre ville avec votre téléphone et ajouter une nouvelle actualité depuis votre ordinateur quand vous rentrez chez vous.
                                </text-slot>
                            </div>
                        </div>
                    </Waves>
                </div>
                <div class='feature'>
                    <title-slot>Satisfait ou rien déboursé  ✨</title-slot>
                    <text-slot>
                        Vous bénéficiez d'une période d'essai de <b>2 mois</b> totalement <b>gratuite</b> et <b>sans engagement</b> pour juger par vous-même si notre offre vous convient.
                        <br />
                        De plus notre solution est vendue par abonnement sans engagement, ce qui vous permet <b>d'aplanir le coût d'une application</b> sur la durée et vous laisse la
                        possibilité de <b>changer d'avis à tout moment</b>.
                    </text-slot>
                </div>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
        TitleSlot,
        TextSlot,
        Waves
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.features
{
    .feature
    {
        .dual
        {
            display: flex;
            flex-direction: column;

            .OnTablet({ flex-direction: row; });

            .image
            {
                width: 100%;
                height: intrinsic;
                object-fit: contain;

                .OnTablet({ width: 40%; });
                .OnDesktop({ width: 50%; });
            }

            .description
            {
                width: 100%;
                margin-top: 10vh;

                .OnTablet({
                    width: 50%;
                    margin-left: 5vw;
                    margin-top: 0;
                });

                .title-slot, .text-slot
                {
                    margin-left: 0;
                    margin-right: 0;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Features.vue